import { graphql } from 'gatsby';
import React, { FC } from 'react';
import { WithClassName } from '../../../utlityTypes';
import { SliceProps, SliceVariation } from '../../types';
import ThreeColumnCards from '../ThreeColumnCards';

type ThreeColumnCardsDataProps = SliceProps<
  'threeColumnCards',
  | SliceVariation<'default', Queries.PrismicThreeColumnCardsDefaultPrimary, Queries.PrismicThreeColumnCardsDefaultItem>
  | SliceVariation<
      'numberedCards',
      Queries.PrismicThreeColumnCardsNumberedCardsPrimary,
      Queries.PrismicThreeColumnCardsNumberedCardsItem
    >
  | SliceVariation<
      'numberedCardsAltBackground',
      Queries.PrismicThreeColumnCardsNumberedCardsAltBackgroundPrimary,
      Queries.PrismicThreeColumnCardsNumberedCardsAltBackgroundItem
    >
  | SliceVariation<
      'brand2GradientStripedCurve',
      Queries.PrismicThreeColumnCardsBrand2GradientStripedCurvePrimary,
      Queries.PrismicThreeColumnCardsBrand2GradientStripedCurveItem
    >
> &
  WithClassName;
/**
 * ThreeColumnCards data component: specifies the fragment and passes the appropriate data to the ThreeColumnCards component.
 */
const ThreeColumnCardsData: FC<ThreeColumnCardsDataProps> = ({ className, slice }) => {
  const items =
    slice.items?.map(({ heading, text, ctaButtonText, ctaLink, cardImage, ...others }) => ({
      heading: heading || '',
      text: text || '',
      cta: { text: ctaButtonText || '', link: ctaLink },
      icon: ('icon' in others && others.icon) || undefined,
      cardImage,
    })) || [];

  return (
    <ThreeColumnCards
      className={className}
      heading={slice.primary.heading}
      text={slice.primary.text || ''}
      items={items}
      variation={slice.variation || 'default'}
    />
  );
};

export default ThreeColumnCardsData;

export const query = graphql`
  fragment ThreeColumnCardsDefault on PrismicThreeColumnCardsDefault {
    primary {
      heading {
        ...RichText
      }
      text
    }
    items {
      cardImage {
        ...Image
      }
      icon
      heading
      text
      ctaButtonText
      ctaLink {
        ...PrismicLink
      }
    }
    variation
  }

  fragment ThreeColumnCardsNumberedCards on PrismicThreeColumnCardsNumberedCards {
    primary {
      heading {
        ...RichText
      }
      text
    }
    items {
      cardImage {
        ...Image
      }
      heading
      text
      ctaButtonText
      ctaLink {
        ...PrismicLink
      }
    }
    variation
  }

  fragment ThreeColumnCardsNumberedCardsAltBackground on PrismicThreeColumnCardsNumberedCardsAltBackground {
    primary {
      heading {
        ...RichText
      }
      text
    }
    items {
      cardImage {
        ...Image
      }
      heading
      text
      ctaButtonText
      ctaLink {
        ...PrismicLink
      }
    }
    variation
  }

  fragment ThreeColumnCardsBrand2GradientStripedCurve on PrismicThreeColumnCardsBrand2GradientStripedCurve {
    primary {
      heading {
        ...RichText
      }
      text
    }
    items {
      cardImage {
        ...Image
      }
      icon
      heading
      text
      ctaButtonText
      ctaLink {
        ...PrismicLink
      }
    }
    variation
  }

  fragment ThreeColumnCards on PrismicPageDataSlicesSlicesType {
    ...ThreeColumnCardsDefault
    ...ThreeColumnCardsNumberedCards
    ...ThreeColumnCardsNumberedCardsAltBackground
    ...ThreeColumnCardsBrand2GradientStripedCurve
  }
`;
